import { render, staticRenderFns } from "./ProjectFlightList.vue?vue&type=template&id=d39fd922&"
import script from "./ProjectFlightList.vue?vue&type=script&lang=js&"
export * from "./ProjectFlightList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports